import { createI18n } from 'vue-i18n';
import CreaturesTranslations from '../locales/CreaturesTranslation.js';
import FormsTranslation from "../locales/FormsTranslation";
import AccountTranslation from "../locales/AccountTranslation";

const messages = {
    en: {
        ...CreaturesTranslations.en,
        ...FormsTranslation.en,
        ...AccountTranslation.en
    },
    fr: {
        ...CreaturesTranslations.fr,
        ...FormsTranslation.fr,
        ...AccountTranslation.fr,
    },
    es: {
        ...CreaturesTranslations.es,
        ...FormsTranslation.es,
        ...AccountTranslation.es,
    },
    de: {
        ...CreaturesTranslations.de,
        ...FormsTranslation.de,
        ...AccountTranslation.de,
    },
    pt: {
        ...CreaturesTranslations.pt,
        ...FormsTranslation.pt,
        ...AccountTranslation.pt,
    },
    it: {
        ...CreaturesTranslations.it,
        ...FormsTranslation.it,
        ...AccountTranslation.it,
    },
    nl: {
        ...CreaturesTranslations.nl,
        ...FormsTranslation.nl,
        ...AccountTranslation.nl,
    },
    zh: {
        ...CreaturesTranslations.zh,
        ...FormsTranslation.zh,
        ...AccountTranslation.zh,
    },
    ja: {
        ...CreaturesTranslations.ja,
        ...FormsTranslation.ja,
        ...AccountTranslation.ja,
    },
    ru: {
        ...CreaturesTranslations.ru,
        ...FormsTranslation.ru,
        ...AccountTranslation.ru,
    },
}

const i18n = createI18n({
    locale: 'en',
    legacy: false,
    messages,
})

export default i18n;
